import { render } from "./HomeView.vue?vue&type=template&id=dca72894&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=dca72894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca72894"]])

export default __exports__